module.exports = __webpack_public_path__ + "static/img/guide-15.5be3f560.png";